var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showModalSuccess)?_c('div',[_c('ModalSuccess')],1):(_vm.showModalError)?_c('div',[_c('ModalError')],1):_vm._e(),_c('div',[_c('HeaderComponent',{attrs:{"home":false}}),(_vm.showWallet)?_c('div',[_c('Wallet')],1):_vm._e(),_c('transition',{attrs:{"name":"fade"}},[_c('Sale')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }